import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';

export const quizService = {
  redirectInfo: slug => axios.get(Pathes.Quiz.redirectInfo(slug)),
  complete: (slug, payload) => axios.post(Pathes.Quiz.complete(slug), payload),
};
